import type { Resource } from '../../';
export const general_errors_renderAlerts_hoverToReveal: Resource = {"default":"Hover to reveal more"};
